'use strict';

var toString = require('./toString.js');

/**
 * Converts the given value to a time string.
 *
 * @param prop - The value to convert to a time string.
 * @returns The converted time string.
 * @deprecated Use built-in time conversion functions instead.
 */ function toTime(prop) {
    return toString(prop);
}

module.exports = toTime;
